import { RadioButtonStates, UI_UNSET, UI_UNSET_VALUE } from '../../types/settings'
import { ISettingsAdapter, ISettingsAdapterArgs, SettingsAdapter } from './settingsAdapter'

export type IRadioButtonStatesAdapterArgs<RawType = '0' | '1' | null> = Omit<
  ISettingsAdapterArgs<RawType, RadioButtonStates, RadioButtonStates | UI_UNSET>,
  'toUiValue' | 'toRawValue'
>

export const RadioButtonStatesAdapter = <RawType = '0' | '1' | null>({
  inputName,
  variable,
  type,
  defaultRawValue,
  initialUiValue = UI_UNSET_VALUE,
  skipFormPopulateOnLoad,
  shouldUseRawValue,
  shouldTreatAsUnset,
  schema
}: IRadioButtonStatesAdapterArgs<RawType>): ISettingsAdapter<
  RawType,
  RadioButtonStates,
  RadioButtonStates | UI_UNSET
> => {
  const toUiValue = (rawValue: any): RadioButtonStates =>
    rawValue === '1' ? RadioButtonStates.on : RadioButtonStates.off

  const toRawValue = (value: RadioButtonStates | UI_UNSET): any => (value === RadioButtonStates.on ? '1' : '0')

  return SettingsAdapter<RawType, RadioButtonStates, RadioButtonStates | UI_UNSET>({
    inputName,
    variable,
    type,
    defaultRawValue,
    initialUiValue,
    toUiValue,
    toRawValue,
    skipFormPopulateOnLoad,
    shouldUseRawValue,
    shouldTreatAsUnset,
    schema
  })
}
